import Icon from './empty.icon.svg';
import css from './empty.module.scss';

export function Empty() {
    return (
        <div className={css.empty}>
            <Icon />
            <span>No items</span>
        </div>
    );
}
